import { cn } from "@design-system/utils";
import { Button, ButtonProps } from "./Button";

type CloseButtonProps = ButtonProps;

export function CloseButton({ className, ...props }: CloseButtonProps) {
  return (
    <Button
      {...props}
      variant="ghost"
      className={cn("h-8 w-8 border text-black dark:text-white", className)}
    >
      X
    </Button>
  );
}
